import React, {Component} from "react";

class Unsubscribe extends Component {
  render() {
    window.location.replace(process.env.REACT_APP_UNSUBSCRIBE_URL);
    return null;
  }
}

export default Unsubscribe;